import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "main-section" }
const _hoisted_2 = { class: "content-section" }
const _hoisted_3 = { class: "text-block full-width" }
const _hoisted_4 = { class: "content-section reverse-layout" }
const _hoisted_5 = { class: "game-description" }
const _hoisted_6 = { class: "game-description game-list" }
const _hoisted_7 = { class: "game-description game-list" }
const _hoisted_8 = { class: "game-description game-list" }
const _hoisted_9 = { class: "game-description" }
const _hoisted_10 = { class: "game-description" }
const _hoisted_11 = { class: "game-description" }
const _hoisted_12 = { class: "content-section reverse-layout" }
const _hoisted_13 = { class: "game-description" }
const _hoisted_14 = { class: "content-section reverse-layout" }
const _hoisted_15 = { class: "game-description" }
const _hoisted_16 = { class: "content-section reverse-layout" }
const _hoisted_17 = { class: "game-description" }
const _hoisted_18 = { class: "content-section reverse-layout" }
const _hoisted_19 = { class: "game-description" }
const _hoisted_20 = { class: "game-description" }
const _hoisted_21 = { class: "game-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accent = _resolveComponent("Accent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "title" }, "Things I learned", -1)),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.learn, (task, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "game-description game-list",
              key: index
            }, _toDisplayString(task), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _cache[38] || (_cache[38] = _createElementVNode("h1", { class: "title" }, "Scene System", -1)),
      _cache[39] || (_cache[39] = _createElementVNode("video", {
        class: "media-video right",
        controls: "",
        "aria-hidden": "true"
      }, [
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/scene_c.mp4",
          type: "video/mp4"
        }),
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/scene.webm",
          type: "video/webm"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1)),
      _createElementVNode("p", _hoisted_5, [
        _cache[2] || (_cache[2] = _createTextVNode("The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Scene Window")
          ])),
          _: 1
        }),
        _cache[3] || (_cache[3] = _createTextVNode(" is the primary interface for interacting with and manipulating entities within the active scene. It presents a real-time view of the world and provides tools for editing entity transforms, adjusting scene parameters, and managing scene content."))
      ]),
      _cache[40] || (_cache[40] = _createElementVNode("p", { class: "game-description" }, "The editor exposes the current transformation operation, allowing users to switch between:", -1)),
      _createElementVNode("ul", null, [
        _createElementVNode("li", _hoisted_6, [
          _cache[5] || (_cache[5] = _createTextVNode("Position (")),
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Translation")
            ])),
            _: 1
          }),
          _cache[6] || (_cache[6] = _createTextVNode(")."))
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[7] || (_cache[7] = [
              _createTextVNode("Rotation")
            ])),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createTextVNode("."))
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createVNode(_component_Accent, null, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("Scale")
            ])),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createTextVNode("."))
        ])
      ]),
      _createElementVNode("p", _hoisted_9, [
        _cache[18] || (_cache[18] = _createTextVNode("The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Hierarchy Window")
          ])),
          _: 1
        }),
        _cache[19] || (_cache[19] = _createTextVNode(" allows the user to look for specific entities and select them. The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("Inspector Window")
          ])),
          _: 1
        }),
        _cache[20] || (_cache[20] = _createTextVNode(" allows the user to ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("add")
          ])),
          _: 1
        }),
        _cache[21] || (_cache[21] = _createTextVNode(", ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("remove")
          ])),
          _: 1
        }),
        _cache[22] || (_cache[22] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("change components")
          ])),
          _: 1
        }),
        _cache[23] || (_cache[23] = _createTextVNode(" on the selected entity. Entities can also be ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("renamed")
          ])),
          _: 1
        }),
        _cache[24] || (_cache[24] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("deleted")
          ])),
          _: 1
        }),
        _cache[25] || (_cache[25] = _createTextVNode("."))
      ]),
      _createElementVNode("p", _hoisted_10, [
        _cache[28] || (_cache[28] = _createTextVNode("Everything in the scene can be undone and redone with the editor action system, with buttons at the top for ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("Undo")
          ])),
          _: 1
        }),
        _cache[29] || (_cache[29] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode("Redo")
          ])),
          _: 1
        }),
        _cache[30] || (_cache[30] = _createTextVNode("."))
      ]),
      _createElementVNode("p", _hoisted_11, [
        _cache[34] || (_cache[34] = _createTextVNode("You can switch between ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[31] || (_cache[31] = [
            _createTextVNode("editor camera")
          ])),
          _: 1
        }),
        _cache[35] || (_cache[35] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [
            _createTextVNode("game camera")
          ])),
          _: 1
        }),
        _cache[36] || (_cache[36] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[33] || (_cache[33] = [
            _createTextVNode("change the lighting")
          ])),
          _: 1
        }),
        _cache[37] || (_cache[37] = _createTextVNode("."))
      ])
    ]),
    _createElementVNode("section", _hoisted_12, [
      _cache[50] || (_cache[50] = _createElementVNode("h1", { class: "title" }, "Sprite Sheet Editor", -1)),
      _cache[51] || (_cache[51] = _createElementVNode("video", {
        class: "media-video left",
        controls: "",
        "aria-hidden": "true"
      }, [
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/sprite_sheet_editor_c.mp4",
          type: "video/mp4"
        }),
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/sprite_sheet_editor.webm",
          type: "video/webm"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1)),
      _createElementVNode("p", _hoisted_13, [
        _cache[45] || (_cache[45] = _createTextVNode("The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[41] || (_cache[41] = [
            _createTextVNode("Sprite Sheet Editor")
          ])),
          _: 1
        }),
        _cache[46] || (_cache[46] = _createTextVNode(" is the primary interface for editing sprite sheets and rects. You can ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("add")
          ])),
          _: 1
        }),
        _cache[47] || (_cache[47] = _createTextVNode(", ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[43] || (_cache[43] = [
            _createTextVNode("remove")
          ])),
          _: 1
        }),
        _cache[48] || (_cache[48] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [
            _createTextVNode("change rects")
          ])),
          _: 1
        }),
        _cache[49] || (_cache[49] = _createTextVNode(". Existing rects can be viewed on the side."))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _cache[57] || (_cache[57] = _createElementVNode("h1", { class: "title" }, "Explorer Window", -1)),
      _cache[58] || (_cache[58] = _createElementVNode("video", {
        class: "media-video right",
        controls: "",
        "aria-hidden": "true"
      }, [
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/explorer_window_c.mp4",
          type: "video/mp4"
        }),
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/explorer_window.webm",
          type: "video/webm"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1)),
      _createElementVNode("p", _hoisted_15, [
        _cache[54] || (_cache[54] = _createTextVNode("The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[52] || (_cache[52] = [
            _createTextVNode("Explorer Window")
          ])),
          _: 1
        }),
        _cache[55] || (_cache[55] = _createTextVNode(" in the engine editor functions as the primary interface for browsing, organizing, and interacting with project assets stored in the ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[53] || (_cache[53] = [
            _createTextVNode("asset directory")
          ])),
          _: 1
        }),
        _cache[56] || (_cache[56] = _createTextVNode(". It is conceptually similar to a file explorer, but with engine-specific asset types and editor integration."))
      ]),
      _cache[59] || (_cache[59] = _createElementVNode("p", { class: "game-description" }, "The Explorer Window supports two primary viewing modes:", -1)),
      _cache[60] || (_cache[60] = _createElementVNode("ul", null, [
        _createElementVNode("li", { class: "game-description game-list" }, "Displays assets in a vertical list."),
        _createElementVNode("li", { class: "game-description game-list" }, "Displays assets as a grid of thumbnails or icons.")
      ], -1))
    ]),
    _createElementVNode("section", _hoisted_16, [
      _cache[64] || (_cache[64] = _createElementVNode("h1", { class: "title" }, "Console Window", -1)),
      _cache[65] || (_cache[65] = _createElementVNode("video", {
        class: "media-video left",
        controls: "",
        "aria-hidden": "true"
      }, [
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/console_window_c.mp4",
          type: "video/mp4"
        }),
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/console_window.webm",
          type: "video/webm"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1)),
      _createElementVNode("p", _hoisted_17, [
        _cache[62] || (_cache[62] = _createTextVNode("The ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[61] || (_cache[61] = [
            _createTextVNode("Console Window")
          ])),
          _: 1
        }),
        _cache[63] || (_cache[63] = _createTextVNode(" serves as the editor’s central interface for displaying and managing logged messages generated by the engine and editor systems. It provides developers with immediate feedback about runtime events, diagnostics, warnings, and errors occurring during development."))
      ])
    ]),
    _createElementVNode("section", _hoisted_18, [
      _cache[79] || (_cache[79] = _createElementVNode("h1", { class: "title" }, "Automating Custom Icon Fonts", -1)),
      _cache[80] || (_cache[80] = _createElementVNode("video", {
        class: "media-video right",
        controls: "",
        "aria-hidden": "true"
      }, [
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/font_generation_tool_c.mp4",
          type: "video/mp4"
        }),
        _createElementVNode("source", {
          src: "/gallusengine/src/mp4/font_generation_tool.webm",
          type: "video/webm"
        }),
        _createTextVNode(" Your browser does not support the video tag. ")
      ], -1)),
      _createElementVNode("p", _hoisted_19, [
        _cache[67] || (_cache[67] = _createTextVNode("As my game engine project grew, so did my need for icons. Font Awesome wasn\"t enough because icons were missing, and I constantly found myself visiting third-party websites to generate custom icon fonts. Frustrated by the process, I decided to ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[66] || (_cache[66] = [
            _createTextVNode("build my own solution")
          ])),
          _: 1
        }),
        _cache[68] || (_cache[68] = _createTextVNode("."))
      ]),
      _createElementVNode("p", _hoisted_20, [
        _cache[71] || (_cache[71] = _createTextVNode("I developed a ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[69] || (_cache[69] = [
            _createTextVNode("Node.js/NPM tool")
          ])),
          _: 1
        }),
        _cache[72] || (_cache[72] = _createTextVNode(" that ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[70] || (_cache[70] = [
            _createTextVNode("automates icon font generation")
          ])),
          _: 1
        }),
        _cache[73] || (_cache[73] = _createTextVNode(". It works by:"))
      ]),
      _cache[81] || (_cache[81] = _createElementVNode("ul", null, [
        _createElementVNode("li", { class: "game-description game-list" }, "Taking icons from a folder."),
        _createElementVNode("li", { class: "game-description game-list" }, "Creating an SVG font."),
        _createElementVNode("li", { class: "game-description game-list" }, "Generating a font file from the SVG."),
        _createElementVNode("li", { class: "game-description game-list" }, "Producing an HTML file for easy previewing and encoding reference.")
      ], -1)),
      _createElementVNode("p", _hoisted_21, [
        _cache[76] || (_cache[76] = _createTextVNode("To integrate seamlessly with my engine, the tool also generates a ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[74] || (_cache[74] = [
            _createTextVNode("C++ header file")
          ])),
          _: 1
        }),
        _cache[77] || (_cache[77] = _createTextVNode(", defining all ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[75] || (_cache[75] = [
            _createTextVNode("icon codes and embedding the font as a byte array")
          ])),
          _: 1
        }),
        _cache[78] || (_cache[78] = _createTextVNode(", allowing ImGui to load it directly from memory."))
      ]),
      _cache[82] || (_cache[82] = _createElementVNode("p", { class: "game-description" }, "This tool eliminated my dependency on external services and made it effortless to expand my engine\"s icon set.", -1))
    ])
  ]))
}